import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Skeleton, Box } from '@mui/material';

const SkeletonTable = ({ rows = 5, column = 5, height = 45 }) => {
  return (

    <Box
      sx={{
        mt: 4,
        p: 2,
        borderRadius: 3,
        border: "1px solid rgba(255,255,255,0.06)",
        background: "#1f2022ff"
      }}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <Skeleton width={40} />
            </TableCell>
            <TableCell>
              <Skeleton width={100} />
            </TableCell>
            <TableCell align="right">
              <Skeleton width={80} />
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {[...Array(rows)].map((row, index) => (
            <TableRow key={index}>
              <TableCell>
                <Skeleton width={20} />
              </TableCell>
              <TableCell>
                <Skeleton width={120} />
              </TableCell>
              <TableCell align="right">
                <Skeleton width={60} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default SkeletonTable;
